import { useTranslation } from "react-i18next";

const useShoppingListTableData = (items) => {
  const { t } = useTranslation();

  const tableHeaders = [t("name"), t("quantity"), t("unit"), t("notes"), t("recipes")];
  const tableRows = items
    ?.filter((item) => !!item)
    .map((item) => [
      item.name,
      item.quantity,
      item.unit,
      item.notes || "",
      item.recipes.map(({ title, day, meal }) => `${t(`tableHeaders.daysOfWeek.${day}`)} ${t(`tableHeaders.mealTimes.${meal}`)}`).join(", "),
    ]);

  return { tableHeaders, tableRows };
};

export default useShoppingListTableData;
